module.exports = __webpack_public_path__ + "static/media/1POLICY49.d9b45c2d.jpg";